import { render, staticRenderFns } from "./DegreeAuditPage.vue?vue&type=template&id=33944a8c&scoped=true&"
import script from "./DegreeAuditPage.vue?vue&type=script&lang=js&"
export * from "./DegreeAuditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33944a8c",
  null
  
)

export default component.exports